import ListWidgetMixin from "../mixins/ListWidgetMixin";

Vue.asyncComponent('ak-popover-menu', {
    mixins: [ListWidgetMixin],
    data() {
        return {
            currentOpen: false,
            dynamicDirection: null,
        }
    },
    props: {
        open: {
            type: Boolean,
            required: false,
        },
        triggerLabel: {
            type: String,
            required: false,
        },
        triggerIcon: {
            type: String,
            required: false,
        },
        direction: {
            type: String,
            required: false,
        },
        items: {
            type: Array,
            required: false,
        },
        showOverflow: {
            type: Boolean,
            default: false
        },
        disableTriggerBackground: {
            type: Boolean,
            default: true
        },
        triggerOutlined: {
            type: Boolean,
            required: false,
            default: false
        },
        triggerSize: {
            type: String,
            required: false,
            default: 'small'
        },
        triggerColorMode: {
            type: String,
            required: false,
        },
        maxHeight: {
            type: String,
        }
    },
    model: {
        prop: 'open',
        event: 'change'
    },
    watch: {
        currentOpen() {
            if(this.currentOpen) {
                this.$emit('show');
            } else {
                this.$emit('hide');
            }
        },
        open(open) {
            this.currentOpen = open;
        }
    },
    methods: {
        toggleMenu() {
            // if we need top open the menu check where we need to open it
            if (!this.currentOpen) {
                this.determineMenuDirection();
            }

            this.$nextTick(() => {
                this.currentOpen = !this.currentOpen;
                this.$emit('change', this.currentOpen);
            });
        },
        closeMenu() {
            this.currentOpen = false;
            this.$emit('change', this.currentOpen);
        },
        determineMenuDirection() {
            // Determine the scrollable parent
            const scrollParent = this.getScrollableParent(this.$el);

            // determine menu position on the default state of the element (bottom - left);
            this.$refs.menu.classList.remove('ak-popover-menu--bottom-left', 'ak-popover-menu--bottom-right','ak-popover-menu--top-left','ak-popover-menu--top-right');
            // get the menu bounding client rect without any transform on it
            this.$refs.menu.style.transition = 'none';
            this.$refs.menu.style.transform = 'initial';
            const menuRect = this.$refs.menu.getBoundingClientRect();
            this.$refs.menu.style.removeProperty('transform');
            this.$refs.menu.style.removeProperty('transition');

            // get te scrollable parent boundingRect
            const parentBottom = scrollParent
                    ? scrollParent.getBoundingClientRect().bottom
                    : document.documentElement.clientHeight;
            const parentTop = scrollParent
                    ? scrollParent.getBoundingClientRect().top
                    : document.querySelector('[data-header]').clientHeight;
            const parentLeft = scrollParent
                    ? scrollParent.getBoundingClientRect().left
                    : 0;


            // We will determine if there is space left and to to bottom if we use the default state of the popover
            // that is to the bottom left
            const spaceLeft = menuRect.left >= parentLeft; // the menu' space to the left of the viewport needs to be parger then that of the scroll parent
            const spaceBottom = menuRect.bottom <= parentBottom; // the menu's space to the bottom needs to be smaller then that of the parentconst spaceTop = menuRect.top - menuRect.height >= parentTop;

            // Also check if there is space at the top for the menu otherwise we will always let it open to the bottom
            // determine the offset from the trigger top to the menu
            const wrapperRect = this.$el.getBoundingClientRect();
            const menuOffset = menuRect.top - (wrapperRect.top + wrapperRect.height);
            // determine the menu's position if it will be shown on top of the trigger
            const menuTopSpace = menuRect.top - menuRect.height - (menuOffset * 2) - wrapperRect.height;
            const spaceTop = menuTopSpace >= parentTop; // the space of the menu in top position needs to be greator or equal then that of the parent


            // Check in which direction we have space
            if (spaceBottom && spaceLeft && (this.direction === 'left' || ! this.direction)) {
                this.dynamicDirection = 'bottom-left';
            } else if (spaceBottom &&  ! spaceLeft && (this.direction === 'right' || ! this.direction)){
                this.dynamicDirection = 'bottom-right';
            } else if ( ! spaceBottom && spaceLeft && (this.direction === 'left' || ! this.direction) && spaceTop){
                this.dynamicDirection = 'top-left';
            } else if ( ! spaceBottom && ! spaceLeft && (this.direction === 'right' || ! this.direction) && spaceTop){
                this.dynamicDirection = 'top-right';
            } else {
                this.dynamicDirection = this.direction ? this.direction : 'bottom-left';
            }
        },
        // Step 1: Find scrollable parent
        getScrollableParent(el) {
            let parent = el.parentElement;
            while (parent) {
                const overflowY = window.getComputedStyle(parent).overflowY;
                const overflowX = window.getComputedStyle(parent).overflowX;
                const isScrollableY = overflowY === 'scroll' || overflowY === 'auto';
                const isScrollableX = overflowX === 'scroll' || overflowX === 'auto';

                if ((isScrollableY && parent.scrollHeight > parent.clientHeight) ||
                        (isScrollableX && parent.scrollWidth > parent.clientWidth)) {
                    return parent;
                }
                parent = parent.parentElement;
            }
            return null;
        }
    },
    created() {
        this.currentOpen = this.open;
    }
}, 'layout/ak-popover-menu.html');
